import React, { Component } from "react";
import moment from "moment";
import redux from "../../common/Redux";
import api, { URL_PATH } from "../../services/API";
import Toast from "../../components/Toast";
class ListGalleryItemScreen extends Component {
  constructor(props) {
    super(props);
    this.state = { images: [],toast: {
      open: false,
      message: "",
      severity: "success"
    } };
  }
  componentDidMount() {
    this.getGalleryItems(this.props.match.params.id);
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ toast: { ...this.state.toast, open: false } });
  };

  getGalleryItems = async (id) => {
    const images = await api(this, "get", URL_PATH.listGalleryItem(id));
    this.setState({ images });
  };
  deleteGallery = async (id) => {
    try {
      const response = await api(this, "delete", URL_PATH.deleteGalleryItem(id));
      this.showToast("Gallery deleted successfully", "success");
      this.getGalleryItems(this.props.match.params.id);
    } catch (error) {
      this.showToast("Failed to delete gallery", "error");
      console.error(error);
    }
  };
  render() {
    return (
      <div className="container">
        <h1>list gallery items here {this.props.match.params.id}</h1>
        <h2
          className="btn btn-success"
          onClick={() => {
            this.props.history.push(
              `/admin/gallery-Item/create/${this.props.match.params.id}`
            );
          }}
        >
          Add images
        </h2>
        <div className="row">
          {this.state.images.map((image) => (
            <div className="col-md-3">
              <img src={image.url} style={{ width: "100%" }} alt="" />

              <div className="row">
                <div className="col-md-6">
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      this.props.history.push(
                        `/admin/gallery/${this.props.match.params.id}/edit/${image.id}`
                      )
                    }
                  >
                    edit
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      window.Alert(
                        {
                          title: "delete",
                          text: "are you sure you want to delete this image",
                          showCancelButton: true,
                        },
                        () => {
                          this.deleteGallery(image.id);
                        }
                      )
                    }
                  >
                    delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Toast
        open={this.state.toast.open}
        message={this.state.toast.message}
        severity={this.state.toast.severity}
        onClose={this.handleCloseToast}
      />
      </div>
    );
  }
}

export default redux(ListGalleryItemScreen);
